goog.provide("shadow.js.shim.module$date_fns$locale$ru$default");
shadow.js.shim.module$date_fns$locale$ru$default = esm_import$date_fns$locale$ru.default;
